import { Box, Paper, Typography } from "@mui/material";
import CircularProgress from "@mui/material/CircularProgress";
import { useStyles } from "./CommonStyle";

const ScanningFooter = () => {
  const classes = useStyles();
  return (
    <Box sx={{ display: 'flex', justifyContent: 'center' }}>
      <Paper className={classes.scanningFooter}>
        <CircularProgress
          size={20}
          sx={{
            marginRight: "0.5rem",
            color: "#FFF",
          }}
        />
        <Typography variant="body2" sx={{ fontStyle: "italic" }}>
          Scanning for malicious code in process
        </Typography>
      </Paper>
    </Box>
  );
};

export default ScanningFooter;
